// ----------------------------------------------------------------------------
// -------------------------------------------------------------------- Imports
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Libraries
import React from "react";
import PropTypes from "prop-types";
import { css } from "glamor";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Components
import { CompositeHeader } from "@bodhi-project/components";
import { Header as SemanticHeader } from "@bodhi-project/semantic-webflow";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Locals
import mobileLogo from "../assets/mobileLogo.png";
import mobileBurger from "../assets/mobileBurger.png";
import mobileCross from "../assets/mobileCross.png";
import MobileNav from "../blocks/MobileNav";
import DesktopNav from "../blocks/DesktopNav";

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Abstractions

const {
  ResponsiveHeader,
  DesktopHeader,
  MobileMenu,
  MobileHeader
} = CompositeHeader;

// ----------------------------------------------------------------------------
// ----------------------------------------------------------------------- Data
// ----------------------------------------------------------------------------
const menu = {
  title: "",
  menu: [
    { title: "Why Us?", link: "/docs/about-dmr" },
    { title: "About Us", link: "/about" },
    { title: "Contact Us", link: "/contact" }
  ],
  buttons: [
    { title: "Login", link: "https://digitalmediareserve.com" },
    { title: "Get Started", link: "https://digitalmediareserve.com" }
  ]
};

// ----------------------------------------------------------------------------
// --------------------------------------------------------------------- Styles
// ----------------------------------------------------------------------------
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Mobile
const semanticHeader = css({
  "& h4.outline, .outline": {
    display: "none"
  }
});
const semanticHeaderClass = semanticHeader.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Mobile
const mobileHeader = css({
  backgroundColor: "#FFFFFF",
  boxShadow: "0px 3px 5px 0px rgba(30,30,30,0.2)",
  border: "unset",
  paddingBottom: 15,
  height: 80
});
const mobileHeaderClass = mobileHeader.toString();

// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ Desktop
const desktopHeaderStyle = css({
  background: "#FFFFFF",
  position: "fixed",
  top: 0,
  width: "100%",
  boxShadow: "0px 3px 5px 0px rgba(30,30,30,0.2)",
  height: 100,
  zIndex: 1000
});
const desktopHeaderStyleClass = desktopHeaderStyle.toString();

// ----------------------------------------------------------------------------
// ------------------------------------------------------------------ Component
// ----------------------------------------------------------------------------
/** Header */
class Header extends React.Component {
  /** standard constructor */
  constructor(props) {
    super(props);
  }

  /** standard renderer */
  render() {
    return (
      <SemanticHeader className={semanticHeaderClass}>
        <h4 className="nocontent outline">
          Digital Media Reserve: Secured Adobe DRM Integration Web Services
        </h4>
        <ResponsiveHeader path={this.props.location}>
          <MobileHeader className={mobileHeaderClass}>
            <img
              id="logo"
              alt="Digital Media Reserve: Logo"
              src={mobileLogo}
              style={{
                height: "10%",
                width: "30.5%",
                marginTop: 20
              }}
            />
            <img
              id="menu"
              alt="menu icon"
              src={mobileBurger}
              style={{ height: 45, width: 45, top: 15, right: 3 }}
            />
            <img
              id="cross"
              alt="close menu icon"
              src={mobileCross}
              style={{ height: 37, width: 37 }}
            />
          </MobileHeader>
          <MobileMenu>
            <MobileNav menu={menu} />
          </MobileMenu>
          <DesktopHeader className={desktopHeaderStyleClass}>
            <DesktopNav menu={menu} />
          </DesktopHeader>
        </ResponsiveHeader>
      </SemanticHeader>
    );
  }
}

Header.propTypes = {
  location: PropTypes.object // eslint-disable-line react/forbid-prop-types
};

// --------------------------------------------------------------------- Export
export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.jsx